import { useCallback } from 'react'

export const useCallbackOnce = <T extends (...args: any[]) => any>(callback: T): T => {
  return useCallback(callback, []) // eslint-disable-line react-hooks/exhaustive-deps
}
